import { F_INDEX } from "../../../constants/routes"

export const navLinks = [
  { href: "#loesung", label: "Lösung" },
  { href: "#partner", label: "Partnerschulen" },
  { href: "#foerderung", label: "Förderung" },
  { href: "#kontakt", label: "Kontakt" },
  { href: "/faq", label: "FAQ" },
  // { href: "#features", label: "Features" },
  // { href: "#newsletter", label: "Newsletter" },
]

export const getHref = (href, location) => {
  if (!location) {
    return F_INDEX
  }

  if (href.startsWith("/")) {
    // special case for /faq, /impressum etc
    return href
  }

  const isIndex = location.pathname === "/"
  const linkPrefix = isIndex ? "" : F_INDEX

  return linkPrefix + href
}

export const formatPrice = (n) => `$${n.toFixed(2)}`
